
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ExtendedContactInfo from "@/apps/shared/components/ExtendedContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import localityService from '@/apps/shared/services/locality-service';
    import cityByPostalAndLocalService from '@/apps/shared/services/CityByPostalAndLocals-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'travelAssistance-tab-One',
        components: {
            XBreadcrumb,
            TitleAndPromotions,
            ExtendedContactInfo,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Asistencia al Viajero",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos personales",
                    product: "Viajes",
                    icon: {
                        src: '/Logos/asistencia-al-viajero.svg',
                        alt: 'Asistencia al Viajero',
                        title: 'Asistencia al Viajero'
                    },
                    iconPromotion: {
                        src: '/Logos/asistencia-al-viajero.svg',
                        alt: 'viajes-promo',
                        title: 'viajes-promo'
                    }
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos Personales', path: '/asistencia-viajero/' },
                ],
                leadId: null,
                referente: null,
                medium: null,
                localityList: function (params) {
                    return localityService.getLocalityList(params)
                },
                selectedLocality: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
            }
        },
        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async getTravelAssistanceDiscountRange() {
                // Descuento web: si hay rango vigente se muestra el banner promocional y el rango
                // queda en sesión para que la cotización lo aplique. Un fallo no frena el flujo
                // (se sigue sin banner y sin descuento).
                try {
                    const response = await DiscountRangeService.getTravelAssistanceDiscountRange();
                    if (response.length > 0) {
                        this.$refs.titlesAndPromotions.setDiscountData({
                            discountRate: response[0].discountMaxValue,
                            containDiscountRange: true,
                            changeTitlePromotions: false,
                        });
                    }
                } catch (error) {
                    console.error("Error al obtener el rango de descuento:", error);
                }
            },

            async comenzar() {
                const extendedContactInfoData = this.$refs.extendedContactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                const { firstName, lastName, email, telephone, areaCode, validTelephone, validEmail } = extendedContactInfoData;

                const validName = firstName && firstName.trim() !== "";
                const validLastName = lastName && lastName.trim() !== "";
                const validateEmail = validEmail;

                if (validName && validLastName && validTelephone && validateEmail && this.selectedLocality != null) {
                    NF.UI.Page.block();

                    // El autocomplete de localidades no trae el id de provincia se resuelve aca para que la cotizacion no pague esta llamada.
                    let provinceId = 0;
                    try {
                        const response = await cityByPostalAndLocalService.GetCityByPostalAndLocal(this.selectedLocality.id, this.selectedLocality.zipCode, 1);
                        provinceId = response?.values?.[0]?.city?.province?.id || 0;
                    } catch (error) {
                        provinceId = 0;
                    }

                    // Guardar datos en sessionStorage para las siguientes pantallas
                    sessionStorage.setItem("DataTabHome", JSON.stringify({
                        firstName: firstName,
                        lastName: lastName,
                        areaCode: areaCode,
                        telephone: telephone,
                        email: email,
                        selectedLocality: { ...this.selectedLocality, provinceId: provinceId }
                    }));

                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, email, location.href, areaCode, telephone, 1018, false, "1", null, lastName, firstName)
                        .then((response) => {
                            sessionStorage.setItem("LeadId", JSON.stringify(response));
                            this.$router.push({
                                name: 'travelAssistance-destination',
                            });
                        })
                        .catch(error => {
                            const statusCode = error.response?.status;
                            this.Bus.$emit('show-service-fail', statusCode, [() => this.comenzar()]);
                        })
                        .finally(() => NF.UI.Page.unblock());
                }
            },

            RedirectToHome() {
                let urlParams = new URLSearchParams(window.location.search);
                let parameter = urlParams.get('test');
                if (parameter != "test") {
                    window.location.href = "https://www.sancorseguros.com.ar/";
                }
            },

            getInitData() {
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    var dataTomador = sessionStorage.getItem("DataTabHome");
                    if (dataTomador != null) {
                        var dataTomadorJson = JSON.parse(dataTomador);
                        this.$refs.extendedContactInfoRef.setFormData(dataTomadorJson);
                        this.selectedLocality = dataTomadorJson.selectedLocality;
                    }
                }
                else {
                    sessionStorage.clear();
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("Medium", this.medium);
                    sessionStorage.setItem("ExitOrContinueModal", "true");

                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': null,
                        'referente': this.referente,
                        'product': 'asistencia-viaje',
                        'event': 'cotizador-asistencia-viaje-view'
                    });
                    window.globalThis._qsie = window.globalThis._qsie || [];
                    window.globalThis._qsie.push('cotizador-asistencia-viaje-view');
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                //this.RedirectToHome();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                await this.pageCustomization();
                // Después de pageCustomization: su InitializeWebSales borra el rango de descuento
                // de la sesión, así que el rango de travel se pide recién acá.
                await this.getTravelAssistanceDiscountRange();
                await this.updateByProductGoogleAnalytics();

                this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
